import { clearSession } from "./auth-storage";

const PUBLIC_PATHS = ["/login"];

export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

let loginRedirectPending = false;

export function invalidateClientSession(): void {
  if (typeof window === "undefined") return;
  clearSession();
  window.dispatchEvent(new CustomEvent("th:session-invalidated"));
}

export function redirectToLoginOnce(): void {
  if (typeof window === "undefined") return;

  invalidateClientSession();

  const pathname = window.location.pathname;
  if (isPublicPath(pathname)) return;
  if (loginRedirectPending) return;

  loginRedirectPending = true;
  const returnUrl = `${pathname}${window.location.search}`;
  window.location.replace(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
}

export function notifySessionRestored(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("th:session-restored"));
}
